import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BundleDetailsNoOffers from './BundleDetailsNoOffers';
import { balanceDataType } from '../../../Home/BalanceSection/balanceTypes';
import {
  BundleDetailsCardsWrapperStyled as BundleDetailsCardsWrapper,
  BundleDetailsDisclaimerStyled as BundleDetailsDisclaimer,
} from './styles/BundleDetailsTabContentStyled';
import CurrentBalance from './CurrentBalance';
import BundleDetailsCard from './BundleDetailsCard';
import alertWarning from '../../../../images/extra-saldo/ico_alert_warning.svg';
import { GoogleTagManager, Strings } from '../../../../helpers';

const BundleDetailsTabContent = ({ data, label, actualBalance, setOffer }) => {
  const hasOffers = data.length !== 0;
  const [openCardIndex, setOpenCardIndex] = useState(null);

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: `/tienda/extra-saldo/${Strings.strToUrl(label)}`,
      pagename: `Tienda - Extra Saldo - ${Strings.strFirstCaseUpper(label)}`,
    });
  }, []);

  const setOpen = selectedIndex => {
    setOpenCardIndex(prevOpen =>
      prevOpen === selectedIndex ? null : selectedIndex
    );
  };

  return (
    <>
      {!hasOffers && <BundleDetailsNoOffers />}
      {hasOffers && (
        <>
          <CurrentBalance actualBalance={actualBalance} label={label} />
          <BundleDetailsCardsWrapper>
            {data.map((offer, index) => (
              <BundleDetailsCard
                key={offer.code}
                offer={offer}
                label={label}
                index={index}
                open={openCardIndex === index}
                setOpen={setOpen}
                setOffer={setOffer}
              />
            ))}
          </BundleDetailsCardsWrapper>
          <BundleDetailsDisclaimer>
            <img src={alertWarning} alt="alert warning" />
            <h3>
              Cobro adicional de ${data[0].commission} por uso de Extra Saldo.
              <br />
              <span>Este monto se descontará de tu próxima recarga</span>
            </h3>
          </BundleDetailsDisclaimer>
        </>
      )}
    </>
  );
};

BundleDetailsTabContent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      commission: PropTypes.number.isRequired,
      cost: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      unity: PropTypes.string.isRequired,
      validity: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  label: PropTypes.string.isRequired,
  actualBalance: balanceDataType.isRequired,
  setOffer: PropTypes.func.isRequired,
};

export default BundleDetailsTabContent;
